import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Button as BaseButton } from '@leroy-merlin-br/backyard-react-ui'

const ghostStyles = ({ theme, variant }) =>
  variant === 'ghost' &&
  css`
    label: clean-filters--ghost;

    &:hover {
      background: ${theme.colors.n200};
    }
  `

export const Button = styled(BaseButton)(ghostStyles)
